import React, { ReactElement, MouseEvent } from 'react'
import { isSpecialClick } from '../../../helpers'

type PropsType = {
  onClick: () => void
  className?: string
  href?: string
  children: ReactElement | ReactElement[]
}

const Link = (props: PropsType): ReactElement => {
  const { onClick } = props

  const onClickHandler = (e: MouseEvent) => {
    if (isSpecialClick(e)) {
      return
    }
    onClick()
    e.preventDefault()
  }

  return <a {...props} onClick={onClickHandler} />
}

export default Link
